import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import store from './store'

Vue.use(Router)

//export default new Router({
const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/categories',
      name: 'categories',
      component: () => import( /* webpackChunkName: "categories" */ './views/Categories.vue'),
      meta: { auth: true }
    },
    {
      path: '/products',
      name: 'products',
      component: () => import( /* webpackChunkName: "products" */ './views/Products.vue'),
      meta: { auth: true }
    },
    {
      path: '/category/:slug',
      name: 'category',
      component: () => import( /* webpackChunkName: "category" */ './views/Category.vue'),
      meta: { auth: true }
    },
    {
      path: '/product/:slug',
      name: 'product',
      component: () => import( /* webpackChunkName: "product" */ './views/Product.vue')
    },
    {
      path: '/checkout',
      name: 'checkout',
      component: () => import( /* webpackChunkName: "checkout" */ './views/Checkout.vue'),
      meta: { auth: true }
    },
    {
      path: '/payment',
      name: 'payment',
      component: () => import( /* webpackChunkName: "payment" */ './views/Payment.vue'),
      meta: { auth: true }
    },
    {
      path: '/profile',
      name: 'profile',
      component: () => import( /* webpackChunkName: "profile" */ './views/Profile.vue'),
      meta: { auth: true }
    },
    {
      path: '/my-order',
      name: 'my-order',
      component: () => import( /* webpackChunkName: "my-order" */ './views/Orders.vue'),
      meta: { auth: true }
    },
    {
      path: '/report-order/:id',
      name: 'report-order',
      component: () => import( /* webpackChunkName: "report-order" */ './views/ReportOrder.vue'),
      meta: { auth: true }
    },
    {
      path: '/iot-view',
      name: 'iot-view',
      component: () => import( /* webpackChunkName: "iot-view" */ './views/IotView.vue'),
      meta: { auth: true }
    },
    {
      path: '/calendar',
      name: 'calendar',
      component: () => import( /* webpackChunkName: "iot-view" */ './views/Calendar.vue'),
      //meta: { auth: true }
    },
    {
      path: '/my-account',
      name: 'account',
      component: () => import( /* webpackChunkName: "my-account" */ './views/Account.vue'),
      meta: { auth: true }
    },
    {
      path: '/reset-password/:token',
      name: 'reset-password-form',
      component: () => import( /* webpackChunkName: "reset-password-form" */ './views/ResetPasswordForm.vue'),
      meta: { auth: false }
    },
    {
      path: '/admin',
      name: 'admin',
      component: () => import( /* webpackChunkName: "admin" */ './views/Admin.vue'),
      meta: { auth: true }
    },
    {
      path: '/login',
      name: 'login',
      component: () => import( /* webpackChunkName: "login" */ './components/Login.vue'),
      meta: { auth: false }
    },
    {
      path: '/users',
      name: 'users',
      component: () => import( /* webpackChunkName: "users" */ './views/User.vue'),
      meta: { auth: true }
    },
    // {
    //   path: '/profit-order',
    //   name: 'profit-order',
    //   component: () => import( /* webpackChunkName: "cashflow" */ './views/ProfitOrder.vue'),
    //   meta: { auth: true }
    // },
    {
      path: '/chart-profit',
      name: 'chart-profit',
      component: () => import( /* webpackChunkName: "chart-profit" */ './views/Profit.vue'),
      meta: { auth: true }
    },
    // {
    //   path: '/profit-product',
    //   name: 'profit-product',
    //   component: () => import( /* webpackChunkName: "profit-product" */ './views/ProfitProduct.vue'),
    //   meta: { auth: true }
    // },
    {
      path: '/cashflow',
      name: 'cashflow',
      component: () => import( /* webpackChunkName: "cashflow" */ './views/Cashflow.vue'),
      meta: { auth: true }
    },
    {
      path: '/store-setting',
      name: 'store-setting',
      component: () => import( /* webpackChunkName: "store-setting" */ './views/StoreSetting.vue'),
      meta: { auth: true }
    },
    {
      path: '/search',
      name: 'search',
      component: () => import( /* webpackChunkName: "search" */ './components/Search.vue'),
      meta: { auth: false }
    },
    {
      path: '/promotion',
      name: 'promotion',
      component: () => import( /* webpackChunkName: "store-setting" */ './views/Promotion.vue'),
      meta: { auth: true }
    },
    {
      path: '/register',
      name: 'register',
      component: () => import( /* webpackChunkName: "register" */ './components/Register.vue'),
      meta: { auth: false }
    },
    {
      path: '/information',
      name: 'information',
      component: () => import( /* webpackChunkName: "information" */ './views/Information.vue'),
      meta: { auth: true }
    },
    {
      path: '/licence',
      name: 'licence',
      component: () => import( /* webpackChunkName: "licence" */ './views/Licence.vue'),
      meta: { auth: true }
    },
    {
      path: '/purchase-order',
      name: 'purchase-order',
      component: () => import( /* webpackChunkName: "purchase-order" */ './views/PurchaseOrder.vue'),
      meta: { auth: true }
    },
    {
      path: '/courier',
      name: 'courier',
      component: () => import( /* webpackChunkName: "courier" */ './views/Courier.vue'),
      meta: { auth: true }
    },
    
    {
      path: '/code-referal-iot',
      name: 'code-referal-iot',
      component: () => import( /* webpackChunkName: "code-referal-iot" */ './views/CodeReveralIot.vue'),
      meta: { auth: true }
    },

  ]
})

router.beforeEach((to, from, next) => {
  // jika routing ada meta auth-nya maka
  if (to.matched.some(record => record.meta.auth)) {
    // jika user adalah guest
    if (store.getters['auth/guest']) {
      // tampilkan pesan bahwa harus login dulu
      store.dispatch('alert/set', {
        status: false,
        text: 'Login first',
        color: 'error',
      })
      store.dispatch('setPrevUrl', to.path)
      // tampilkan form login
      store.dispatch('dialog/setComponent', 'login')
    }
    else {
      next()
    }
  }
  else {
    next()
  }
})

export default router;